module.exports = __webpack_public_path__ + "img/creditBook.716f3a58.svg";